import React, { useEffect, useRef, useState } from "react";
import { Header, Icon, Popup, Segment } from "semantic-ui-react";

import { Spacer } from "./Spacer";

import { openPlayer } from "./api";
import { useIsMobile } from "./utils";

export function AlbumSummary({ album, onClose }) {
  const summaryRef = useRef();
  const [position, setPosition] = useState();

  const isMobileDevice = useIsMobile();

  const { playlist } = album;

  useEffect(() => {
    if (!summaryRef.current) return;

    const rect = summaryRef.current.getBoundingClientRect();

    setPosition([-rect.width / 2, -rect.height / 2 - 250]);
  }, [setPosition]);

  return (
    <>
      <Segment className="album-summary" basic>
        <Header>
          {playlist.title}

          <Icon
            link
            className="external-link"
            name="external alternate"
            onClick={() => openPlayer(album)}
          />

          <Icon
            name="window close outline"
            onClick={onClose}
            style={{ fontSize: 20, float: "right" }}
          />
        </Header>

        <div className="album-titles">
          <div>
            <ol>
              {playlist.playlist.map((track) => (
                <li key={track.id}>
                  <p>{track.title}</p>
                </li>
              ))}
            </ol>
          </div>

          <Spacer width={30} />

          <div ref={summaryRef}>
            {isMobileDevice ? (
              <img alt="album cover" src={`${album.image}`} />
            ) : (
              <Popup
                basic
                on="click"
                offset={position}
                trigger={<img alt="album cover" src={`${album.image}`} />}
                content={
                  <img
                    alt="album cover"
                    src={`${album.bigImage}`}
                    className="album-big"
                  />
                }
              />
            )}
          </div>
        </div>
      </Segment>
    </>
  );
}
